export default {
  globalConfig: {
    title: '全局设置',
  },
}
